/** CoStar.Api.MarketAnalytics.SearchMarkets.Localization.Models.ColumnType */
export var ColumnType;
(function (ColumnType) {
    ColumnType[ColumnType["AllGeography"] = 0] = "AllGeography";
    ColumnType[ColumnType["SearchFilter"] = 1] = "SearchFilter";
    ColumnType[ColumnType["MapLayer"] = 2] = "MapLayer";
    ColumnType[ColumnType["TrendsOption"] = 3] = "TrendsOption";
    ColumnType[ColumnType["Property"] = 4] = "Property";
    ColumnType[ColumnType["PropertyHistory"] = 5] = "PropertyHistory";
    ColumnType[ColumnType["PropertyHistoryDataTable"] = 6] = "PropertyHistoryDataTable";
    ColumnType[ColumnType["AnalyticExport"] = 7] = "AnalyticExport";
})(ColumnType || (ColumnType = {}));
